import { useCallback, useEffect, useMemo, useState } from 'react';
import { saltLevels as api } from '../api-client/index';
export function useSaltLevels() {
    const [readings, setReadings] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const load = useCallback(async () => {
        setLoading(true);
        setError(null);
        try {
            const data = await api.list();
            setReadings(data);
        }
        catch {
            setError('Failed to load salt levels');
        }
        finally {
            setLoading(false);
        }
    }, []);
    useEffect(() => {
        void load();
    }, [load]);
    const latest = useMemo(() => {
        return readings.length > 0 ? readings[0] : null;
    }, [readings]);
    const report = useCallback(async (percentage, date) => {
        const reading = await api.report(percentage, date);
        setReadings(prev => [reading, ...prev]);
        return reading;
    }, []);
    const remove = useCallback(async (id) => {
        await api.remove(id);
        setReadings(prev => prev.filter(r => r.id !== id));
    }, []);
    const clearAll = useCallback(async () => {
        await api.clearAll();
        setReadings([]);
    }, []);
    return { readings, latest, loading, error, report, remove, clearAll, load };
}
